<template lang="pug">
#v-description.description.container
  p.description__primary
    | 2020 年 5G 應用進入商轉階段，搶先掌握「毫米波」技術，就是關鍵贏家！
    br
    | 工欲善其事，必先利其器，充分利用毫米波網路分析儀，就可以掌握 5G 關鍵指標。
  .description__reward
    p.description__sub
      | 即日起到 7/30 23:59 ，只要填寫「量測知識問卷」留下資料，就可以獲得
      em.description__sub.description__sub--em 「KEYSIGHT 毫米波量測白皮書」
      | ，協助您的量測更精確、值得信賴、有效率，還可參加好禮抽獎！
    img.description__ebook(v-if='!$store.state.mobile', src='@/assets/ebook.png', alt='eBook', width='352')
    img.description__ebook(v-else, src='@/assets/m-ebook.png', alt='eBook', width='228')
</template>

<script>
export default {
  name: 'Description',
}
</script>

<style lang="sass" scoped>
.description
  padding-bottom: 60px
  padding-top: 60px
  &__primary
    +font(24px, #E50029, 44px, 1.5px)
    margin-bottom: 40px
    text-align: center
  &__reward
    +flexbox(null, center)
    border: 6px solid #EBEBEB
    padding: 22px 60px 22px 90px
  &__sub
    +font(20px, #5A5A5A, 38px, 2px)
    &--em
      +font(null, #E50020, null, null, 500)
  &__ebook
    margin-left: 60px

@media (max-width: 991px)
  .description
    padding-bottom: 40px
    padding-top: 40px
    &__primary
      +font(16px, null, 26px, 1.77px)
      margin-bottom: 26px
    &__reward
      flex-direction: column
      padding: 20px 14px
    &__sub
      +font(14px, null, 24px, 1.39px)
      margin-bottom: 10px
    &__ebook
      margin-left: 0
</style>
